<template>
  <div>
    <div class="checkbox">
      <input :id="`checkbox_${instanceId}`"
             v-model="fieldValue"
             v-bind="$attrs"
             type="checkbox"
             class="checkbox-field">

      <label :for="`checkbox_${instanceId}`"
             class="checkbox-label"
             :class="{ invalid: showValidation && !isValid }">
        {{ placeholder }}
      </label>
    </div>

    <div v-if="showValidation && !isValid"
         class="validation-message">
      <span>Required</span>
    </div>
  </div>
</template>

<script>
import vmodelMixin from "~/mixins/vmodelMixin";
import fieldMixin from "~/mixins/fieldMixin";
import validationMixin from "~/mixins/validationMixin";

export default {
  name: "CheckboxField",
  mixins: [vmodelMixin, fieldMixin, validationMixin],
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ( {
    mutable: null,
    fieldValue: null
  } ),
  computed: {
    isValid () {
      let result = true;

      if ( this.required && !this.fieldValue ) {
        result = false;
      }

      return result;
    }
  },
  watch: {
    fieldValue: {
      handler ( val ) {
        this.copyToMutable( val );
      },
      deep: true
    },
    mutable: {
      handler ( val ) {
        this.copyFromMutable( val );
      }
    }
  },
  created () {
    this.copyFromMutable( this.mutable );
  },
  methods: {
    copyToMutable ( fieldValue ) {
      if ( !this.mutable.fieldValues ) {
        this.mutable.fieldValues = [];
      }

      const match = this.mutable.fieldValues.find(
        x => x.name === this.name
      );

      if ( fieldValue ) {
        if ( !match ) {
          this.mutable.fieldValues.push( {
            fieldId: this.id,
            name: this.name,
            itemId: null,
            value: fieldValue
          } );
        } else {
          const index = this.mutable.fieldValues.indexOf( match );
          this.mutable.fieldValues[index].value = fieldValue;
        }
      } else if ( match ) {
        const index = this.mutable.fieldValues.indexOf( match );
        this.mutable.fieldValues.splice( index, 1 );
      }
    },
    copyFromMutable ( mutable ) {
      const { fieldValues } = mutable;

      if ( fieldValues ) {
        const matchingFieldValue = fieldValues.find( x => x.name === this.name );
        if ( matchingFieldValue ) {
          this.fieldValue = matchingFieldValue.value;
        } else {
          this.fieldValue = null;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.checkbox-field {
  margin-right: 5px;
}

.checkbox-label {
  font-weight: normal;
}
</style>
